import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core'
import { BehaviorSubject } from 'rxjs'; 

import { sla, kpiRelease, kpiband, kpiViewHistory, kpiInbox, kpi, kpiViewWorkFlow, slakpiInteraction, year, filecontent} from './../../../models/slakpi';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { Router, ActivatedRoute, Params } from '@angular/router';

import Swal from 'sweetalert2';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'kpi-info',
  templateUrl: './kpi-info.component.html',
  styleUrls: ['./kpi-info.component.css']

})
export class KPIInfoComponent implements OnInit {
  AttachmentList: any=[];
  fileItemCount: any;
  public selTab = true;
  public selTab2 = false;
  public kpiMapping_data: any;
  public kpiRelease_data_count: any;
  public kpiViewWorkflow_data: any;
  public kpiTargetHistory_data: any;
  public interaction_data: any;
  public fields_mappings: Object;
  public yearData: any;
  public quaterData: any;
  public yearUno_chart: number =0;
  public quaterUno_chart: number = 0;
  public kpirUno_chart: number = 0;
  //@Input('kpiUno')
  kpiUnoSelected: number = 0;
  @Input() set kpiUno(value: number) {
    this.bSubject.next(value);
  }
  public kpiViewHistory_data: any;
  public kpiCodeDetail: kpi;
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 50;
  historydisableMore: boolean = true;
  public isDataEntryError: boolean = false;
  public txtDataEntryError: string = '';

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public workflowStartIndex: number = 1;
  public workflowMaxCount: number = 300;
  workflowdisableMore: boolean = true;
  public selectedIndex: number = 0;
  //public loggined_User: number = 2;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  tenantUno?: number;
  isToggle: boolean = true;
  public isAdmin: boolean = false;
  public isPageEdit: boolean = false;
  private bSubject = new BehaviorSubject(0);
  public condition3_data: any;
  noDataImg: any;
  constructor(public restApi: SLAKPIApiService, public adminService: AdminApiService, private toaster: ToasterService,
    private userService: UserService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService) {

    this.bSubject.subscribe(value => {

      if (value != 0) {
        this.kpirUno_chart = value;
        this.selectedIndex = 0;
        this.kpiUnoSelected = value;
        //this.kpiCodeDetail = new kpiInbox();
        this.loadKPICodeDetails(value);
        //this.loadKPIViewHistory(value, true);
        this.user = this.userService.getUserInfo();
        this.login_UserID = this.user.id;
        this.currentYear = this.user.currentYear;

        this.getFiles(this.kpiUnoSelected);
      }
    });

  }


  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.tenantUno = 1;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
     
  
  }
  selectionChange(selectionEvent: any) {

  }
  viewKPI(kpiUno: any) {
    
    this.bSubject.next(kpiUno);
  }

   


   
  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = kpiTrnUno;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPIs(inpValue)
      .subscribe(data => {

        this.kpiCodeDetail = data[0];

        //this.KPIViewDialog.show();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  getFiles(kpiUno: any) {
    this.AttachmentList = [];
    let inpValue = new filecontent();
    inpValue.masterUNo = kpiUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.KPI_FileSelect(inpValue)
      .subscribe(data => {
        
        this.AttachmentList = data;
        //this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  onChangeTab(selectedTab: any) {
    if (selectedTab == 'general') {
      this.selTab = true;
      this.selTab2 = false;

    }
    
    else if (selectedTab == 'attachment') {
      this.selTab = false;
      this.selTab2 = true;
     

    }
    return false;
  }

  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.kpiUnoSelected.toString();
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.KPI_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }
}


